import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetafrenzyGuard } from 'ngx-metafrenzy';

import { PricingComponent } from './pricing.component';

const routes: Routes = [
  {
    path: '',
    component: PricingComponent,
    canActivate: [MetafrenzyGuard],
    data: {
      metafrenzy: {
        title: $localize`:@@metaDataWipperozPricingTitle:Discover the cheapest services platform for free - no credit card`,
        tags: [
          {
            name: 'description',
            content: $localize`:@@metaDataWipperozPricingDescription:Sign up for free and start earning today. Weather you work remotely or face to face, use our platform to connect with new customers`
          },
          {
            name: 'og:title',
            content: $localize`:@@metaDataWipperozPricingOgTitle:Discover the cheapest services platform for free - no credit card`
          },
          {
            name: 'og:description',
            content: $localize`:@@metaDataWipperozPricingOgDescription:Sign up for free and start earning today. Weather you work remotely or face to face, use our platform to connect with new customers`
          },
          {
            name: 'og:url',
            content: $localize`:@@metaDataWipperozPricingOgUrl:https://www.wipperoz.com/en/pricing`
          },
          {
            name: 'twitter:url',
            content: $localize`:@@metaDataWipperozPricingTwitterUrl:https://www.wipperoz.com/en/pricing`
          },
          {
            name: 'twitter:title',
            content: $localize`:@@metaDataWipperozPricingTwitterTitle:Discover the cheapest services platform for free - no credit card`
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:site',
            content: '@wipperoz'
          },
          {
            name: 'twitter:description',
            content: $localize`:@@metaDataWipperozPricingTwitterDescription:Sign up for free and start earning today. Weather you work remotely or face to face, use our platform to connect with new customers`
          }
        ]
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PricingRoutingModule {}
